import axios from "../../../util/axios";
// 通用接口，有数据权限限制
export default {
    /** 查询商品列表 */
    queryList: (data) => axios.post({url: "/basedata/product/info/queryList", data}),
    /** 根据商品id查询商品详情 */
    findById: (id) => axios.get({url: "/basedata/product/info/findById", data: {id}}),
    /** 保存商品 */
    save: (data) => axios.post({url: "/basedata/product/info/save", data}),
    /** 删除商品 */
    delete: (id) => axios.del({url: "/basedata/product/info/delete", data: {id}}),
    /** 更新商品状态 */
    updateStatus: (id, status) => axios.get({url: "/basedata/product/info/updateStatus", data: {id, status}}),
    /** 导入商品（异步，formData：file） */
    importExcel: (formData) => axios.post({url: "/basedata/product/info/importExcel", data: formData}),
    /** 查询商品导入状态（前端每5秒轮询） */
    importStatus: () => axios.get({url: "/basedata/product/info/importStatus"}),

}

